/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiFieldValidationResult } from "./ApiFieldValidationResult";
import {
    ApiFieldValidationResultFromJSON,
    ApiFieldValidationResultFromJSONTyped,
    ApiFieldValidationResultToJSON,
} from "./ApiFieldValidationResult";

/**
 *
 * @export
 * @interface ApiBulkUploadValidationResult
 */
export interface ApiBulkUploadValidationResult {
    /**
     *
     * @type {Date}
     * @memberof ApiBulkUploadValidationResult
     */
    timestamp?: Date;
    /**
     *
     * @type {Array<ApiFieldValidationResult>}
     * @memberof ApiBulkUploadValidationResult
     */
    validationResults?: Array<ApiFieldValidationResult>;
    /**
     * If non-zero, check Message for the error description
     * @type {number}
     * @memberof ApiBulkUploadValidationResult
     */
    errorNo?: number;
    /**
     *
     * @type {string}
     * @memberof ApiBulkUploadValidationResult
     */
    message?: string;
    /**
     *
     * @type {number}
     * @memberof ApiBulkUploadValidationResult
     */
    identity?: number;
    /**
     *
     * @type {string}
     * @memberof ApiBulkUploadValidationResult
     */
    identityStr?: string;
}

/**
 * Check if a given object implements the ApiBulkUploadValidationResult interface.
 */
export function instanceOfApiBulkUploadValidationResult(
    value: object,
): value is ApiBulkUploadValidationResult {
    return true;
}

export function ApiBulkUploadValidationResultFromJSON(
    json: any,
): ApiBulkUploadValidationResult {
    return ApiBulkUploadValidationResultFromJSONTyped(json, false);
}

export function ApiBulkUploadValidationResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ApiBulkUploadValidationResult {
    if (json == null) {
        return json;
    }
    return {
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        validationResults:
            json["validationResults"] == null
                ? undefined
                : (json["validationResults"] as Array<any>).map(
                      ApiFieldValidationResultFromJSON,
                  ),
        errorNo: json["errorNo"] == null ? undefined : json["errorNo"],
        message: json["message"] == null ? undefined : json["message"],
        identity: json["identity"] == null ? undefined : json["identity"],
        identityStr:
            json["identityStr"] == null ? undefined : json["identityStr"],
    };
}

export function ApiBulkUploadValidationResultToJSON(
    value?: ApiBulkUploadValidationResult | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        validationResults:
            value["validationResults"] == null
                ? undefined
                : (value["validationResults"] as Array<any>).map(
                      ApiFieldValidationResultToJSON,
                  ),
        errorNo: value["errorNo"],
        message: value["message"],
        identity: value["identity"],
        identityStr: value["identityStr"],
    };
}
